import _noop from 'lodash/noop';

import Cookie from 'js-cookie';
import superagent from 'superagent';

let metrics = _noop;

async function getSystemInfo(commonOptions) {
  const { body } = await superagent.get('/_avia/system/info2').send().withCredentials();

  return Promise.resolve({
    ...commonOptions,
    ENVID: body.ENVID,
    referrer: body.referrer,
    referrer_mrk: body.referrer_mrk,
  });
}
function metricsInitialize() {
  const KM = require('@ott/utility-km').default;
  const vid = Cookie.get('vid');
  const sid = Cookie.get('sid');
  const abst = Cookie.get('abst');
  const acceptLanguage = Cookie.get('accept_language');

  const getSystemInfoPromise = getSystemInfo({
    vid,
    sid,
    abst,
    accept_language: acceptLanguage,
  });

  return function metrics(type, additionalOptions = {}, meta = {}) {
    getSystemInfoPromise.then((options) => {
      if (!type || typeof KM !== 'function') {
        return;
      }

      if (__DEV__) {
        console.log('km-event--->', type, additionalOptions, meta);
        return;
      }

      switch (type) {
        default:
          KM(
            type,
            {
              obj: {
                ...options,
                ...additionalOptions,
              },
            },
            meta
          );

          break;
      }
    });
  };
}

if (__CLIENT__) {
  metrics = metricsInitialize();
}

export default metrics;
